import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page40',
  templateUrl: './page40.component.html',
  styleUrls: ['./page40.component.css']
})
export class Page40Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
